
(() => {
  const DRAWER = '#CartPopup';
  const ITEM = '.upcart-product-item';
  const PROP = '.upcart-item-property';
  const ANCHOR = '.upcart-item-properties-anchor-after';
  const PREVIEW = 'tee-preview-design';
  const RE = /_customization_id\s*:\s*([a-z0-9-]{8,})/i;

  function getId(item) {
    for (const el of item.querySelectorAll(PROP)) {
      const t = (el.textContent || '').trim();
      const m = t.match(RE);
      if (m && m[1]) return m[1];
      const strong = el.querySelector('strong');
      if (strong && /_customization_id/i.test(strong.textContent || '')) {
        const span = el.querySelector('span');
        if (span && span.textContent) return span.textContent.trim();
      }
    }
    return '';
  }

  function addPreview(item) {
    const id = getId(item);
    if (!id) return;
    if (item.querySelector(`.${PREVIEW}[data-customization-id="${CSS.escape(id)}"]`)) return;
    const host = document.createElement('div');
    host.className = PREVIEW;
    host.setAttribute('data-customization-id', id);
    const anchor = item.querySelector(ANCHOR);
    if (anchor) anchor.insertAdjacentElement('afterend', host);
    else item.appendChild(host);
  }

  function scan(root = document) {
    root.querySelectorAll(ITEM).forEach(addPreview);
  }

  function watch(drawer) {
    const mo = new MutationObserver(muts => {
      muts.forEach(m => {
        m.addedNodes.forEach(n => {
          if (n.nodeType !== 1) return;
          if (n.matches?.(ITEM)) addPreview(n);
          n.querySelectorAll?.(ITEM).forEach(addPreview);
        });
      });
    });
    mo.observe(drawer, { childList: true, subtree: true });
    scan(drawer);
  }

  function init() {
    const d = document.querySelector(DRAWER);
    if (d) return watch(d);
    const mo = new MutationObserver(() => {
      const x = document.querySelector(DRAWER);
      if (x) { mo.disconnect(); watch(x); }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

